import { Card, Image, Segment } from 'semantic-ui-react';
import EditListingModal from './EditListingModal';

const ListingSearchPageItem = ({ listings }) => {
  const getUrl = url => {
    var [start, end] = url.split('upload/');
    var update = [start, 'upload/ar_4:3,q_auto:good,', end].join('');
    return update.replace('.png', '.webp').replace('.jpg', '.webp');
  };
  const Trigger = item => (
    <Card key={item.id}>
      <Image style={{ height: 'auto', width: '100%' }} ui={false} wrapped src={getUrl(item.imageUrl)} />

      <Card.Content>
        <Card.Header>{item.description1}</Card.Header>
        <Card.Description>{item.description2}</Card.Description>
        <Card.Meta>
          <div>{item.address}</div>
          <div>
            {item.city} {item.state}, {item.zip}
          </div>
        </Card.Meta>
        <Card.Content extra>{item.firm.name}</Card.Content>
      </Card.Content>
    </Card>
  );

  return (
    <Segment>
      <Card.Group itemsPerRow={5} divided className="listing-item-group">
        {listings.map((listing, idx) => (
          <EditListingModal trigger={Trigger(listing)} item={listing} key={idx} />
        ))}
      </Card.Group>
    </Segment>
  );
};

export default ListingSearchPageItem;
